import { getLocaleFirstDayOfWeek } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {HomeService} from '../../_services/home.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  data:any={matka_game:[]};
  help:any;
  showDeep:boolean=false;
  constructor(private homeService:HomeService) { }

  ngOnInit(): void {
      this.getToday();
      var today = new Date();
      var forDate = new Date('2023-11-15');
      if(today.getTime() <= forDate.getTime())
      {
        this.showDeep = true;
      }
      
  }

  getRandomColor()
  {
      var color = "#";
      for (var i = 0; i < 3; i++)
      {
          var part = Math.round(Math.random() * 255).toString(16);
          color += (part.length > 1) ? part : "0" + part;
      }
      return color;
  }

  getTime(data){
    var time = "00:00:00";
    var interval = setInterval(function(){
      // data.end = data.end.replace(' ', "TT")
      
      var dedline = new Date(data.monthname).getTime();
      var now = new Date().getTime();
      var t = dedline - now;
      // var t = data.endString;
      // console.log(t, dedline, now);
      var hours = Math.floor((t%(1000*60*60*24))/(1000*60*60));
      var minutes = Math.floor((t%(1000*60*60))/(1000*60));
      var seconds = Math.floor((t%(1000*60))/1000);
      
      if(minutes != 0 || seconds != 0 && minutes >=0 && seconds >=0)
      {
        time = hours+":"+(minutes<10?'0'+minutes:minutes)+":"+(seconds<10?'0'+seconds:seconds);
        
        document.getElementById('countdown').innerHTML=time;
      }else{
        this.getToday();
        clearInterval(interval);
      }
    },1000);
  }

  getToday(){
    this.homeService.getToday().subscribe((data) => {
      data.matka_game.map((d, i)=>{
        data.matka_game[i].color = this.getRandomColor();
      })
      this.data = data;
      this.help = '91'+data.help.text;
      console.log(data);
       this.getTime(data.game_timer)
    })
  }

}
